<div class="sidebar" id="left-sidebar-tabs">
  @if (!isLeftSidebarHidden()) {
    <mat-card class="sidebar-card" [style.width.px]="width()">
      <mat-card-header>
        <mat-card-title class="tabs-header">
          <div class="tabs-header__row">
            <div class="tabs-header__tabs" role="tablist" aria-label="Sidebar tabs">
              <button
                type="button"
                mat-button
                role="tab"
                class="tab-button"
                [class.tab-button--active]="selectedTab() === 'collars'"
                [attr.aria-selected]="selectedTab() === 'collars'"
                [attr.tabindex]="selectedTab() === 'collars' ? 0 : -1"
                (click)="selectTab('collars')"
              >
                <span class="tab-button__label">{{ primaryTabLabel() }}</span>
              </button>
              @if (showSecondaryTab()) {
                <button
                  type="button"
                  mat-button
                  role="tab"
                  class="tab-button"
                  [class.tab-button--active]="selectedTab() === 'animals'"
                  [attr.aria-selected]="selectedTab() === 'animals'"
                  [attr.tabindex]="selectedTab() === 'animals' ? 0 : -1"
                  (click)="selectTab('animals')"
                >
                  <span class="tab-button__label">{{ secondaryTabLabel() }}</span>
                </button>
              }
            </div>

            <div class="tabs-header__header-actions">
              <ng-content select="[headerActions]"></ng-content>
            </div>

            <div class="tabs-header__action">
              <button
                type="button"
                mat-icon-button
                class="collapse-button"
                aria-label="Collapse sidebar"
                (click)="toggleLeftSidebarVisibility()"
              >
                <mat-icon class="collapse-button__icon">chevron_left</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        @if (!showSecondaryTab() || selectedTab() === 'collars') {
          <ng-content select="[collarsTab]"></ng-content>
        } @else {
          <ng-content select="[animalsTab]"></ng-content>
        }
      </mat-card-content>
    </mat-card>
  }

  @if (isLeftSidebarHidden()) {
    <button
      type="button"
      mat-button
      class="toggle-sidebar-button"
      aria-label="Expand sidebar"
      (click)="toggleLeftSidebarVisibility()"
    >
      <mat-icon class="toggle-sidebar-button__icon">chevron_right</mat-icon>
    </button>
  }
</div>
